// extracted by mini-css-extract-plugin
module.exports = {"action":"BonusAllowancesTable__action--1XauP","icons":"BonusAllowancesTable__icons--26px9","through":"BonusAllowancesTable__through--3tSXx"};